import { Check } from "lucide-react";
import { SERVICES } from "@/lib/api";

export const ServiceStep = ({ category, setCategory, serviceId, setServiceId }) => (
  <div>
    <div className="mb-8 inline-flex rounded-full border border-white/15 p-1" data-testid="booking-category-toggle">
      {["residential", "commercial"].map((c) => (
        <button key={c} onClick={() => setCategory(c)} data-testid={`booking-category-${c}`}
          className={`rounded-full px-5 py-2.5 text-sm font-bold capitalize transition-colors duration-300 ${category === c ? "bg-acid text-black" : "text-zinc-300 hover:text-white"}`}>
          {c}
        </button>
      ))}
    </div>
    <div className="grid gap-3">
      {SERVICES.filter((s) => s.category === category).map((s) => {
        const on = serviceId === s.id;
        return (
          <button key={s.id} onClick={() => setServiceId(s.id)} data-testid={`booking-service-${s.id}`}
            className={`group flex items-start justify-between gap-6 border p-6 text-left transition-all duration-300 ${on ? "border-[var(--acid)] bg-[#EDB89E]/10" : "border-white/10 bg-[#111317] hover:border-white/30"}`}>
            <span>
              <span className="block text-xl font-bold text-zinc-50">{s.name}</span>
              <span className="mt-2 block text-sm text-zinc-400">{s.blurb}</span>
            </span>
            <span className={`mt-1 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${on ? "border-[var(--acid)] bg-acid text-black" : "border-white/20"}`}>
              {on && <Check className="h-4 w-4" />}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);
